<template>
	<div>
		<Loader v-if="loading" />
		<b-card
			:class="{ border: !back }"
			:footer-bg-variant="!footerBackground ? 'primary' : 'dark-gray'"
			:footer-class="!footerBackground ? 'text-white' : ''">
			<template #header>
				<div class="row">
					<div class="col-lg-4 col-6 logo-bg d-flex align-items-center justify-content-center">
						<img alt="PagBrasil" class="img-responsive" src="@/assets/images/logo-pagbrasil.svg" />
					</div>
					<div class="col-lg-8 col-6 bg-primary">
						<span class="header-title">{{ title }}</span>
					</div>
				</div>
			</template>
			<template v-if="back" #footer>
				<router-link
					:class="!footerBackground ? 'back-icon-white' : 'back-icon-dark'"
					:event="!footerBackground ? 'click' : ''"
					:to="backRoute"
					class="back-icon"
					>Voltar
				</router-link>
			</template>
			<slot></slot>
		</b-card>
	</div>
</template>
<script>
	import Loader from "@/components/Main/Loader";

	export default {
		props: ["title", "back", "backRoute", "footerBackground", "loading"],
		components: {
			Loader,
		},
	};
</script>
<style lang="scss">
	@import "@/assets/scss/colors";

	* {
		border: none;
	}

	.card {
		-webkit-box-shadow: 42px 17px 67px 0px rgba(0, 0, 0, 0.14);
		-moz-box-shadow: 42px 17px 67px 0px rgba(0, 0, 0, 0.14);
		box-shadow: 42px 17px 67px 0px rgba(0, 0, 0, 0.14);
		padding: 0px;
		border: none !important;
	}

	.border {
		border-bottom: 8px solid #e7e7e7 !important;
	}

	.card-header {
		padding: 0 15px;
	}

	.card-header img {
		width: 75%;
		height: auto;
	}

	.card-header .row div {
		margin: 0;
		padding: 18px 30px;
	}

	.card-footer {
		padding-left: 70px;
		padding-right: 70;
	}

	.card-text {
		padding: 20px 50px;
	}

	.card-body {
		border: none;
	}

	.card-text p {
		color: #686361;
		font-family: "Nunito Sans", sans-serif;
		font-size: 16px;
		letter-spacing: 0;
		line-height: 25px;
	}

	.card-text p strong {
		font-weight: bold;
		color: #32302f;
		font-family: "Nunito Sans", sans-serif;
	}

	.header-title {
		color: #fff;
		font-size: 22px;
		font-weight: 200;
	}

	.logo-bg {
		background-color: $dark-blue;
		padding: 0 20px !important;
	}

	.back-icon {
		position: relative;
		padding-left: 2rem;
	}

	.back-icon-dark::before {
		background: url("~@/assets/images/icons/back-dark.svg");
	}

	.back-icon-white::before {
		background: url("~@/assets/images/icons/back-white.svg");
	}

	.back-icon::before {
		content: "";
		display: block;
		height: 1rem;
		width: 1rem;
		top: 0.3rem;
		left: 0;
		position: absolute;
		background-repeat: no-repeat;
	}
</style>
